import React from "react";
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import Logout from "./components/Logout/Logout";
import DocumentPage from "./pages/DocumentPage";
import Documents from "./pages/Documents";
import Documentation from "./pages/Documentation";
import FeatureStory from "./pages/FeatureStory";
import SettingsPage from "./pages/Settings";


export default function AppRoutes() {
    const location = useLocation();

    return (
        <Routes>
            <Route exact path="/" element={<Documents />} />
            <Route exact path="/home" element={<Documents />} />
            {/* A REVISION HOLDS SEVERAL PARKOUR DOCS, so the address carries both. The revision
                alone means "the first part in reading order" -- what a link written before there
                could be several of them meant, and what somebody arriving from QMS's record page
                sensibly means. The pair names one exactly. */}
            <Route path="/document/:revisionUSID" element={<DocumentPage />} />
            <Route path="/document/:revisionUSID/:documentUSID" element={<DocumentPage />} />
            {/* THE ACCOUNT MENU HAS ALWAYS OFFERED "Help" and it navigated here, where nothing
                was served -- so the catch-all below sent the reader to the document list and the
                menu item did nothing, silently. */}
            {/* NOT GATED IN THE ROUTER. The page itself asks the server what this caller may do
                and shows the controls accordingly, and the service refuses a write without the
                privilege -- which is the half that counts. A route guard would only decide what
                somebody is SHOWN. */}
            <Route exact path="/settings" element={<SettingsPage />} />
            <Route exact path="/help" element={<Documentation />} />
            <Route exact path="/documentation" element={<Documentation />} />
            {/* A FEATURE PAGE, READABLE BEFORE SIGNING IN, because it is reached from the
                splash and the splash is what somebody sees when they are not signed in. It is the
                product's account of itself rather than anybody's document. */}
            <Route path="/feature/:slug" element={<FeatureStory />} />
            <Route exact path="/logout" element={<Logout />} />
            <Route path="/*" element={<Navigate to="/" replace state={{
                referrer: {
                    pathname: location.pathname,
                    search: location.search,
                },
            }} />} />
        </Routes>
    );
}
